import React from "react";
import { RowDataByTargetId } from "../financial-target.types";
import { ColDef, GridApi } from "ag-grid-community";
import { filterRowsByTargetFilters } from "../helpers";
import { MappedFinancialTarget } from "components/product-collection/footer/types";

/**
 * Create rows for the financial target grid and filter rows based on targets
 * definitions, which will be used inside columns value getters
 *
 * IMPORTANT: `columnDefs` is required to listen for column modifications on main grid even though it's not used in any line.
 * TODO: Remove `columnDefs` from dependencies once we have a better way to listen for column modifications
 *
 * @param targets targets list
 * @param gridApi connected grid api
 * @param columnDefs columns defs
 * @returns RowData
 */
export const useFilteredRowData = (
    targets: MappedFinancialTarget[],
    gridApi: GridApi,
    columnDefs: ColDef[]
): RowDataByTargetId => {
    // Mapping all row Data to be either blank or to have the target plan values
    return React.useMemo(() => {
        const rows = [];
        gridApi?.forEachNodeAfterFilter((row) => {
            rows.push(row);
        });
        const filteredRowsByTargetId: RowDataByTargetId = targets.reduce((acc, target) => {
            const { targetId, filters } = target;
            const filteredRows = filterRowsByTargetFilters(filters, rows);
            acc[targetId] = filteredRows;
            return acc;
        }, {});

        return filteredRowsByTargetId;
    }, [targets, gridApi, columnDefs]); // eslint-disable-line react-hooks/exhaustive-deps
};
